// Get label from column, either a responsive label or the default label
export const getColumnLabel = (column, dataStore) => {
    const { label, responsiveConfig } = column;
    if (dataStore && responsiveConfig) {
        const { breakpointSize } = dataStore;
        const breakpointConfig = responsiveConfig[breakpointSize];
        if (breakpointConfig && breakpointConfig.label) {
            return breakpointConfig.label;
        }
    }
    return label;
};

export default getColumnLabel;



// WEBPACK FOOTER //
// ./src/utils/getColumnLabel.ts